// Import action types related to home primary data
import {
  ELE_RESULT_LIST_FETCH_DATA_SUCCESS,
  ELE_RESULT_LIST_HAVE_ERROR,
  ELE_RESULT_LIST_ARE_LOADING,
} from "../actionType";

// Retrieve default data from local storage if available, otherwise set as an empty array
// Define the initial state for the HomePrimaryReducer
const initialState = {
  data: [],
  loading: true,
  error: [], // Initialize error as null for better error handling
};

// Reducer function to handle home primary-related actions and update state accordingly
export function EleResultsReducer(state = initialState, action) {
  switch (action.type) {
    // Handle error case when fetching home primary data
    case ELE_RESULT_LIST_HAVE_ERROR:
      return {
        ...state,
        error: action.hasError, // Update the error state with the error from the action
        loading: false, // Set loading to false since the request is complete
      };

    // Handle loading state when home primary data is being fetched
    case ELE_RESULT_LIST_ARE_LOADING:
      return {
        ...state,
        data: action.isLoading ? [] : state.data,
        loading: action.isLoading, // Update the loading state with the loading status from the action
      };

    // Handle success case when home primary data is successfully fetched
    case ELE_RESULT_LIST_FETCH_DATA_SUCCESS:
      return {
        ...state,
        data: action.homePrimary, // Update the data state with the fetched home primary data
        loading: false, // Set loading to false since the request is complete
        error: null, // Clear any previous errors
      };

    // Return the current state by default if action type is not recognized
    default:
      return state;
  }
}
